export default "__VITE_ASSET__CyrwQjps__"